import styled from 'styled-components'

export const SpinnerWrapper = styled.div`
  margin-right: 10px;
  height: 24px;
  overflow: hidden;
`
